module.exports = __webpack_public_path__ + "img/nivel_luz.b3513f3c.svg";